<div class="root-container">
  <div
    class="container d-flex flex-row align-items-center justify-content-between"
    >
    <div class="banner">
      <div class="banner-content">
        <!-- @if (isLogged()) {
        <div class="sidebar my-auto">
          <customer-sidebar
            [links]="navLinks"
            [user]="user()"
            (onLogout)="logout()"
            />
          </div>
          } -->

          <a routerLink="/" class="my-auto logo"
            ><img src="assets/images/common/company_logo_v2_dark.png"
          /></a>

          @if (auth.isAuthenticated()) {
            <div class="banner-search">
              <search-suggest [category]="user()?.category ?? 'all'" />
            </div>
          }

          <div class="text-links">
            @for (link of navLinks; track $index) {
              <nav-link [link]="link" [authUser]="isLogged()" />
            }
          </div>

          @if(!isLogged()){
            <div class="sidebar my-auto">
              <customer-sidebar
                [links]="navLinks"
                [user]="user()"
                (onLogout)="logout()"
                />
              </div>
              } @if(isLogged()){
              <div class="d-flex align-items-center icon-links">
                <div class="d-flex align-items-center gap-3">
                  <header-notifications />
                  <div class="sidebar my-auto">
                    <customer-sidebar
                      [links]="navLinks"
                      [user]="user()"
                      (onLogout)="logout()"
                      [cartLength]="cart().length"
                      />
                    </div>
                  </div>
                  <a routerLink="/browse/cart" class="cart-link"
                    ><button-badge icon="bi-cart2" [badge]="cart().length"
                  /></a>
                  <button-badge
                    #web_user_badge
                    class="web-user-badge"
                    icon="bi-person-circle"
                    [badge]="0"
                    [dropdown]="true"
                    >
                    <div class="dropdown-header" slot="header">
                      @if (user()?.image) {
                        <img
                [src]="
                  user()?.image ?? 'assets/images/defaults/default_user.png'
                "
                          class="profile-img"
                          alt="profile"
                          />
                        } @else {
                          <i class="bi bi-person-circle"></i>
                        }
                        <div class="details">
                          <h3>{{ username() }}</h3>
                          <span>{{ user()?.email }}</span>
                        </div>
                      </div>
                      <div
                        class="dropdown-body"
                        slot="body"
                        (click)="web_user_badge.close()"
                        >
                        <div class="link" [routerLink]="whoAmI() + '/profile'">
                          <i class="bi bi-person"></i> Profile
                        </div>
                        <div class="link" routerLink="/faq">
                          <i class="bi bi-question-circle"></i> FAQs
                        </div>
                        <div class="link" (click)="logout()">
                          <i class="bi bi-box-arrow-right"></i> Logout
                        </div>
                      </div>
                    </button-badge>
                  </div>
                }
              </div>
            </div>
            @if (!isLogged()) {
              <div (click)="login()" class="button-login">
                <i class="bi bi-box-arrow-in-right"></i> Login
              </div>
              <a routerLink="/register" class="btn-signup">Sign Up</a>
            }
          </div>
        </div>